export default class Tree {
    constructor(game, wallStartPosition, scale, variant) {
        this.game = game
        this.scale = scale
        this.height = 431 * this.scale
        this.width = 213 * this.scale
        this.image = document.getElementById('obstacleStrom' + variant)

        this.x = wallStartPosition
        this.y = game.height - this.height
        this.readyToDestroy = false
    }
    update(deltaTime) {
        this.x -= this.game.gameSpeed * deltaTime
        if(this.x + this.width < 0) {
            this.readyToDestroy = true
        }
    }
    draw(context) {
        context.globalAlpha = 1
        context.drawImage(this.image, this.x, this.y, this.width, this.height)
    }
}